import { z } from 'zod';

// Validačná schéma pre osobné údaje
export const personalInfoSchema = z.object({
  meno: z.string().min(2, 'Meno musí mať aspoň 2 znaky'),
  priezvisko: z.string().min(2, 'Priezvisko musí mať aspoň 2 znaky'),
  ulica: z.string().min(3, 'Ulica musí mať aspoň 3 znaky'),
  mesto: z.string().min(2, 'Mesto musí mať aspoň 2 znaky'),
  psc: z.string().regex(/^\d{3}\s?\d{2}$|^\d{5}$/, 'PSČ musí byť vo formáte 12345 alebo 123 45'),
  krajina: z.string().min(2, 'Krajina musí mať aspoň 2 znaky'),
  datum_narodenia: z.string().refine(
    (val) => {
      const dateRegex = /^(0?[1-9]|[12][0-9]|3[01])\.(0?[1-9]|1[0-2])\.(19|20)\d{2}$/;
      if (!dateRegex.test(val)) return false;

      const parts = val.split('.');
      const [day, month, year] = parts.map(part => parseInt(part, 10));
      const date = new Date(year, month - 1, day);

      return (
        date.getDate() === day &&
        date.getMonth() === month - 1 &&
        date.getFullYear() === year
      );
    },
    { message: 'Zadajte platný dátum narodenia vo formáte DD.MM.YYYY' }
  ),
  telefon: z.string().regex(/^(\+?[0-9]{1,4})?[ ]?[0-9]{3}[ ]?[0-9]{3}[ ]?[0-9]{3}$/, 'Zadajte platné telefónne číslo'),
  email: z.string().email('Zadajte platnú emailovú adresu'),
  email_confirm: z.string().email('Zadajte platnú emailovú adresu'),
  ice: z.string().optional(),
  strava: z.enum(['Vegetariánska', 'Normálna'], {
    errorMap: () => ({ message: 'Prosím, vyberte si typ stravy' })
  }),
  ubytko_typ: z.enum(['Stan(vlastný)', 'Chata IPEĽ, Chatka'], {
    errorMap: () => ({ message: 'Prosím, vyberte si typ ubytovania' })
  }),
  platba: z.enum(['Prevodom na účet', 'Na mieste'], {
    errorMap: () => ({ message: 'Prosím, vyberte si spôsob platby' })
  }),
  ubytko_pozn: z.string().optional(),
  lek_zaznamy: z.string().optional(),
}).refine(data => data.email === data.email_confirm, {
  message: "Emailové adresy sa nezhodujú",
  path: ["email_confirm"],
});
